import { render, staticRenderFns } from "./ContentFeedUnlockFeed.vue?vue&type=template&id=23386bb6&"
import script from "./ContentFeedUnlockFeed.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedUnlockFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports